module.exports = __webpack_public_path__ + "img/bicicletta.241d94a5.svg";